import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AuthService } from '../../core/services/api/auth.service';
import { MenuitemComponent } from '../menuitem/menuitem.component';

@Component({
    selector: 'app-menu',
    imports: [MenuitemComponent, RouterModule],
    templateUrl: './menu.component.html',
    styleUrl: './menu.component.scss'
})
export class MenuComponent {
    model: MenuItem[] = [];
    private readonly authService = inject(AuthService);

    rolUser = this.authService.getUserRoles();

    private readonly userBranch: string = this.authService.getCurrentUser()?.branch || '';

    isLaboratoryBranch(): boolean {
        return this.userBranch === 'ARCO - LABORATORIO';
    }

    constructor() {}

    haveRole(role: string): boolean {
        return this.rolUser.includes(role);
    }

    ngOnInit() {
        this.model = [
            {
                label: 'Inicio',
                items: [
                    {
                        label: 'Dashboard',
                        icon: 'pi pi-fw pi-gauge',
                        routerLink: ['/sys/dashboard']
                    }
                ]
            },

            {
                label: 'Secciones',
                items: [
                    {
                        label: 'Carga de Datos',
                        icon: 'pi pi-fw pi-cog',
                        visible: this.haveRole('Root') || this.haveRole('Secretaria') || this.haveRole('Radiólogo') || this.haveRole('Encargado') || this.haveRole('Recursos Humanos'),
                        items: [
                            {
                                label: 'Pacientes',
                                icon: 'pi pi-fw pi-users',
                                visible: this.haveRole('Root') || this.haveRole('Secretaria') || this.haveRole('Radiólogo') || this.haveRole('Encargado') || this.haveRole('Recursos Humanos'),
                                routerLink: ['/sys/identity/patient/list']
                                // items: [
                                //     {
                                //         label: 'Nuevo',
                                //         icon: 'pi pi-fw pi-sign-in',
                                //         visible: this.haveRole('warehouse_operator') || this.haveRole('delivery_person') || this.haveRole('manager') || this.haveRole('admin') || this.haveRole('Root'),
                                //         routerLink: ['/sys/identity/patient/create']
                                //     },
                                //     {
                                //         label: 'Listar',
                                //         icon: 'pi pi-fw pi-times-circle',
                                //         visible: this.haveRole('warehouse_operator') || this.haveRole('delivery_person') || this.haveRole('manager') || this.haveRole('admin') || this.haveRole('Root'),
                                //         routerLink: ['/sys/identity/patient/list']
                                //     }
                                // ]
                            },
                            {
                                label: 'Doctores',
                                icon: 'pi pi-fw pi-address-book',
                                visible: this.haveRole('Root') || this.haveRole('Secretaria') || this.haveRole('Radiólogo') || this.haveRole('Encargado') || this.haveRole('Recursos Humanos'),
                                routerLink: ['/sys/identity/doctor/list']
                                //   items: [
                                //     {
                                //       label: 'Nuevo',
                                //       icon: 'pi pi-fw pi-sign-in',
                                //       visible: this.haveRole('warehouse_operator') || this.haveRole('delivery_person') || this.haveRole('manager') || this.haveRole('admin') || this.haveRole('Root'),
                                //       routerLink: ['/sys/identity/doctor/create'],
                                //     },
                                //     {
                                //       label: 'Listar',
                                //       icon: 'pi pi-fw pi-times-circle',
                                //       visible: this.haveRole('warehouse_operator') || this.haveRole('delivery_person') || this.haveRole('manager') || this.haveRole('admin') || this.haveRole('Root'),
                                //       routerLink: ['/sys/identity/doctor/list'],
                                //     },
                                //   ]
                            },
                            {
                                label: 'Seguros',
                                icon: 'pi pi-fw pi-building-columns',
                                visible: this.haveRole('Root'),
                                items: [
                                    {
                                        label: 'Nuevo',
                                        icon: 'pi pi-fw pi-sign-in',
                                        visible: this.haveRole('Root'),
                                        routerLink: ['/sys/identity/secure/create']
                                    },
                                    {
                                        label: 'Convenios',
                                        icon: 'pi pi-fw pi-lock',
                                        visible: this.haveRole('Root')
                                        // routerLink: ['/erp/order/archived'],
                                    },
                                    {
                                        label: 'Listar',
                                        icon: 'pi pi-fw pi-times-circle',
                                        visible: this.haveRole('Root'),
                                        routerLink: ['/sys/identity/secure/list']
                                    },
                                    {
                                        label: 'Sucursales',
                                        icon: 'pi pi-fw pi-lock',
                                        visible: this.haveRole('Root'),
                                        routerLink: ['/sys/identity/secure/subsidiaries']
                                    }
                                ]
                            },
                            {
                                label: 'Usuarios',
                                icon: 'pi pi-fw pi-user',
                                visible: this.haveRole('Root'),
                                routerLink: ['/sys/identity/user/list']
                                // items: [
                                //     {
                                //         label: 'Nuevo',
                                //         icon: 'pi pi-fw pi-sign-in',
                                //         visible: this.haveRole('warehouse_operator') || this.haveRole('delivery_person') || this.haveRole('manager') || this.haveRole('admin') || this.haveRole('Root'),
                                //         routerLink: ['/sys/identity/user/create']
                                //     },
                                //     {
                                //         label: 'Listar',
                                //         icon: 'pi pi-fw pi-times-circle',
                                //         visible: this.haveRole('warehouse_operator') || this.haveRole('delivery_person') || this.haveRole('manager') || this.haveRole('admin') || this.haveRole('Root'),
                                //         routerLink: ['/sys/identity/user/list']
                                //     }
                                // ]
                            }
                        ]
                    },
                    {
                        label: 'Atención - Ordenes',
                        icon: 'pi pi-fw pi-inbox',
                        visible: this.haveRole('Root') || this.haveRole('Secretaria') || this.haveRole('Radiólogo') || this.haveRole('Encargado') || this.haveRole('Recursos Humanos'),
                        items: [
                            {
                                label: 'Ordenes',
                                icon: 'pi pi-fw pi-receipt',
                                visible: !this.isLaboratoryBranch() && (this.haveRole('Root') || this.haveRole('Secretaria') || this.haveRole('Radiólogo') || this.haveRole('Encargado') || this.haveRole('Recursos Humanos')),
                                items: [
                                    {
                                        label: 'Nueva',
                                        icon: 'pi pi-fw pi-sign-in',
                                        visible: this.haveRole('Root') || this.haveRole('Secretaria') || this.haveRole('Radiólogo') || this.haveRole('Encargado') || this.haveRole('Recursos Humanos'),
                                        routerLink: ['/sys/clinical/new']
                                    },
                                    {
                                        label: 'Generadas',
                                        icon: 'pi pi-fw pi-database',
                                        visible: this.haveRole('Root') || this.haveRole('Radiólogo') || this.haveRole('Encargado') || this.haveRole('Recursos Humanos'),
                                        routerLink: ['/sys/clinical/pendiente']
                                    },
                                    {
                                        label: 'Resultados',
                                        icon: 'pi pi-fw pi-check-circle',
                                        visible: this.haveRole('Root') || this.haveRole('Radiólogo') || this.haveRole('Encargado') || this.haveRole('Recursos Humanos'),
                                        routerLink: ['/sys/clinical/resultado']
                                    },
                                    {
                                        label: 'Listado',
                                        icon: 'pi pi-fw pi-check-circle',
                                        visible: this.haveRole('Root') || this.haveRole('Secretaria') || this.haveRole('Radiólogo') || this.haveRole('Encargado') || this.haveRole('Recursos Humanos'),
                                        routerLink: ['/sys/clinical/list']
                                    }
                                ]
                            },
                            {
                                label: 'Ordenes - Laboratorio',
                                icon: 'pi pi-fw pi-receipt',
                                visible: this.haveRole('Root') || this.haveRole('Secretaria') || this.haveRole('Radiólogo') || this.haveRole('Encargado') || this.haveRole('Recursos Humanos'),
                                items: [
                                    {
                                        label: 'Nueva',
                                        icon: 'pi pi-fw pi-sign-in',
                                        visible: this.haveRole('Root') || this.haveRole('Secretaria') || this.haveRole('Radiólogo') || this.haveRole('Encargado') || this.haveRole('Recursos Humanos'),
                                        routerLink: ['/sys/clinical/new-laboratory']
                                    },
                                    {
                                        label: 'Generadas',
                                        icon: 'pi pi-fw pi-database',
                                        visible: this.isLaboratoryBranch() && (this.haveRole('Root') || this.haveRole('Radiólogo') || this.haveRole('Encargado') || this.haveRole('Secretaria') || this.haveRole('Recursos Humanos')),
                                        routerLink: ['/sys/clinical/pendent-laboratory']
                                    },
                                    // {
                                    //     label: 'Generadas Sucursales',
                                    //     icon: 'pi pi-fw pi-database',
                                    //     visible: this.isLaboratoryBranch() && (this.haveRole('Root') || this.haveRole('Radiólogo') || this.haveRole('Encargado') || this.haveRole('Secretaria')),
                                    //     routerLink: ['/sys/clinical/pendent-branch-laboratory']
                                    // },
                                    {
                                        label: 'Resultados',
                                        icon: 'pi pi-fw pi-check-circle',
                                        visible: this.haveRole('Root') || this.haveRole('Radiólogo') || this.haveRole('Encargado') || this.haveRole('Recursos Humanos'),
                                        routerLink: ['/sys/clinical/result-laboratory']
                                    },
                                    {
                                        label: 'Listado',
                                        icon: 'pi pi-fw pi-check-circle',
                                        visible: this.haveRole('Root') || this.haveRole('Secretaria') || this.haveRole('Radiólogo') || this.haveRole('Encargado') || this.haveRole('Recursos Humanos'),
                                        routerLink: ['/sys/clinical/list-laboratory']
                                    },
                                    {
                                        label: 'Tablero de Control',
                                        icon: 'pi pi-fw pi-table',
                                        visible: this.isLaboratoryBranch() && (this.haveRole('Root') || this.haveRole('Secretaria') || this.haveRole('Encargado') || this.haveRole('Recursos Humanos')),
                                        routerLink: ['/sys/clinical/board-laboratory']
                                    }
                                ]
                            }
                        ]
                    },

                    {
                        label: 'Compras / Proveedores',
                        icon: 'pi pi-fw pi-cog',
                        visible: this.haveRole('Root'),
                        items: [
                            // {
                            //     label: 'Acerca de',
                            //     icon: 'pi pi-fw pi-id-card'
                            //     // routerLink: ['/auth/access'],
                            // }
                        ]
                    },
                    {
                        label: 'Facturación',
                        icon: 'pi pi-fw pi-user',
                        visible: this.haveRole('Root'),
                        items: [
                            {
                                label: 'Cobranza',
                                icon: 'pi pi-fw pi-sign-in',
                                visible: this.haveRole('Root')
                                // routerLink: ['/auth/login'],
                            },
                            {
                                label: 'Facturas',
                                icon: 'pi pi-fw pi-times-circle',
                                visible: this.haveRole('Root')
                                // routerLink: ['/auth/error'],
                            },
                            {
                                label: 'Recibos',
                                icon: 'pi pi-fw pi-lock',
                                visible: this.haveRole('Root')
                                // routerLink: ['/auth/access'],
                            },
                            {
                                label: 'Depositos',
                                icon: 'pi pi-fw pi-lock',
                                visible: this.haveRole('Root')
                                // routerLink: ['/auth/access'],
                            }
                        ]
                    },
                    {
                        label: 'Reportes',
                        icon: 'pi pi-fw pi-briefcase',
                        visible: this.haveRole('Root') || this.haveRole('Administrador'),
                        items: [
                            {
                                label: 'Órdenes Facturadas',
                                icon: 'pi pi-fw pi-receipt',
                                visible: this.haveRole('Root') || this.haveRole('Administrador'),
                                routerLink: ['/sys/clinical/invoiced-orders-report']
                            },
                            {
                                label: 'Totales Diarios',
                                icon: 'pi pi-fw pi-chart-bar',
                                visible: this.haveRole('Root') || this.haveRole('Administrador'),
                                routerLink: ['/sys/clinical/daily-totals-report']
                            }
                        ]
                    },
                    {
                        label: 'Caja',
                        icon: 'pi pi-fw pi-briefcase',
                        visible: this.haveRole('Root'),
                        // routerLink: ['/pages'],
                        items: [
                            {
                                label: 'Apertura / Cierre',
                                icon: 'pi pi-fw pi-sign-in',
                                visible: this.haveRole('Root')
                                // routerLink: ['/auth/login'],
                            },
                            {
                                label: 'Movimiento',
                                icon: 'pi pi-fw pi-times-circle',
                                visible: this.haveRole('Root')
                                // routerLink: ['/auth/error'],
                            },
                            {
                                label: 'Ajustes',
                                icon: 'pi pi-fw pi-lock',
                                visible: this.haveRole('Root')
                                // routerLink: ['/auth/access'],
                            }
                            // ,
                            // {
                            //     label: 'Depositos',
                            //     icon: 'pi pi-fw pi-lock'
                            //     // routerLink: ['/auth/access'],
                            // }
                        ]
                    }
                ]
            },
            {
                label: 'Cajeros',
                items: [
                    {
                        label: 'Caja',
                        icon: 'pi pi-fw pi-sign-in',
                        visible: this.haveRole('Root') || this.haveRole('Secretaria') || this.haveRole('Radiólogo') || this.haveRole('Encargado') || this.haveRole('Recursos Humanos'),
                        routerLink: ['/sys/cashier']
                    },
                    {
                        label: 'Aprobaci\u00f3n de cajas',
                        icon: 'pi pi-fw pi-check',
                        visible: this.haveRole('Root') || this.haveRole('Radi\u00f3logo') || this.haveRole('Encargado'),
                        routerLink: ['/sys/cashier-reports/approval']
                    },
                    {
                        label: 'Verificaci\u00f3n de cajas',
                        icon: 'pi pi-fw pi-shield',
                        visible: this.haveRole('Root') || this.haveRole('Administrador') || this.haveRole('Contador') || this.haveRole('Recursos Humanos'),
                        routerLink: ['/sys/cashier-reports/verification']
                    },
                ]
            },

            {
                label: 'EXTRAS',
                items: [
                    {
                        label: 'Presupuesto',
                        icon: 'pi pi-fw pi-calculator',
                        routerLink: ['/sys/clinical/order-price']
                    },
                    {
                        label: 'Configuraciones',
                        icon: 'pi pi-fw pi-cog',
                        visible: this.haveRole('Root'),
                        items: [
                            {
                                label: 'Roles',
                                icon: 'pi pi-fw pi-shield',
                                visible: this.haveRole('Root'),
                                routerLink: ['/sys/settings/access']
                            },
                            {
                                label: 'Estudios',
                                icon: 'pi pi-fw pi-ticket',
                                visible: this.haveRole('Root'),
                                routerLink: ['/sys/settings/studies']
                            },
                            // {
                            //     label: 'Estados',
                            //     icon: 'pi pi-fw pi-list',
                            //     visible: this.haveRole('warehouse_operator') || this.haveRole('delivery_person') || this.haveRole('manager') || this.haveRole('admin') || this.haveRole('Root'),
                            //     routerLink: ['/sys/settings/status']
                            // },
                            {
                                label: 'Categorias',
                                icon: 'pi pi-fw pi-list-check',
                                visible: this.haveRole('Root'),
                                routerLink: ['/sys/settings/category']
                            },
                            {
                                label: 'Sucursales',
                                icon: 'pi pi-fw pi-building-columns',
                                visible: this.haveRole('Root'),
                                routerLink: ['/sys/settings/sucursales']
                            },
                            {
                                label: 'Feriados',
                                icon: 'pi pi-fw pi-calendar',
                                visible: this.haveRole('Root'),
                                routerLink: ['/sys/settings/feriados']
                            },
                            {
                                label: 'Tipos / Estados',
                                icon: 'pi pi-fw pi-bookmark',
                                visible: this.haveRole('Root'),
                                routerLink: ['/sys/settings/tipo']
                            },
                            {
                                label: 'Timbrados',
                                icon: 'pi pi-fw pi-receipt',
                                visible: this.haveRole('Root'),
                                routerLink: ['/sys/settings/timbrado']
                            },
                            {
                                label: 'Acerca de',
                                icon: 'pi pi-fw pi-id-card',
                                visible: this.haveRole('Root'),
                                routerLink: ['/sys/auth/access']
                            }
                        ]
                    },
                    {
                        label: 'Aplicaciones',
                        icon: 'pi pi-fw pi-external-link',
                        items: [
                            {
                                label: 'Sitio Web',
                                icon: 'pi pi-fw pi-warehouse',
                                url: 'https://www.arco.com.py',
                                target: '_blank'
                            },
                            {
                                label: 'App Informes',
                                icon: 'pi pi-fw pi-clipboard',
                                url: 'https://informes.arco.com.py',
                                target: '_blank'
                            },
                            {
                                label: 'Odonto Arco',
                                icon: 'pi pi-fw pi-graduation-cap',
                                url: 'https://doctores.arco.com.py',
                                target: '_blank'
                            },
                            {
                                label: 'App Pacientes',
                                icon: 'pi pi-fw pi-user',
                                url: 'https://pacientes.arco.com.py',
                                target: '_blank'
                            },
                            {
                                label: 'Tienda Arco',
                                icon: 'pi pi-fw pi-gift',
                                url: 'https://pacientes.arco.com.py',
                                target: '_blank'
                            },
                            {
                                label: 'Avancemos',
                                icon: 'pi pi-fw pi-dollar',
                                url: 'https://sys.avancemos.com.py',
                                target: '_blank'
                            },
                            {
                                label: 'Distrident',
                                icon: 'pi pi-fw pi-shop',
                                url: 'https://sys.distrident.com.py',
                                target: '_blank'
                            }
                        ]
                    }
                ]
            }
        ];
        // this.model = [
        //     {
        //         label: 'Inicio',
        //         items: [
        //             {
        //                 label: 'Dashboard',
        //                 icon: 'pi pi-fw pi-gauge',
        //                 routerLink: ['/sys/dashboard']
        //             }
        //         ]
        //     },
        //     {
        //         label: 'E-COMMERCE',
        //         items: [
        //             {
        //                 label: 'Pedidos',
        //                 icon: 'pi pi-fw pi-gift',
        //                 visible: this.haveRole('warehouse_operator') || this.haveRole('delivery_person') || this.haveRole('manager') || this.haveRole('admin') || this.haveRole('Root'),
        //                 items: [
        //                     {
        //                         label: 'Picking de Ordenes',
        //                         icon: 'pi pi-fw pi-chart-line',
        //                         visible: this.haveRole('warehouse_operator') || this.haveRole('delivery_person') || this.haveRole('manager') || this.haveRole('admin') || this.haveRole('Root')
        //                         // routerLink: ['/dd/cp/orders/orders']
        //                     },
        //                     {
        //                         label: 'Romaneo de Ordenes',
        //                         icon: 'pi pi-fw pi-database',
        //                         visible: this.haveRole('warehouse_operator') || this.haveRole('delivery_person') || this.haveRole('manager') || this.haveRole('admin') || this.haveRole('Root')
        //                         // routerLink: ['/dd/cp/orders/picking-orders']
        //                     },
        //                     {
        //                         label: 'Ordenes',
        //                         icon: 'pi pi-fw pi-database',
        //                         visible: this.haveRole('manager') || this.haveRole('admin') || this.haveRole('Root')
        //                         // routerLink: ['/dd/cp/orders']
        //                     },
        //                     {
        //                         label: 'Facturas',
        //                         icon: 'pi pi-fw pi-database',
        //                         visible: this.haveRole('manager') || this.haveRole('admin') || this.haveRole('Root')
        //                         // routerLink: ['/dd/cp/orders/invoice']
        //                     }
        //                 ]
        //             },
        //             {
        //                 label: 'Favoritos',
        //                 icon: 'pi pi-fw pi-heart',
        //                 visible: this.haveRole('manager') || this.haveRole('admin') || this.haveRole('Root')
        //                 // routerLink: ['/dd/cp/favorites']
        //             },
        //             {
        //                 label: 'E-Commerce',
        //                 icon: 'pi pi-fw pi-cart-plus',
        //                 visible: this.haveRole('manager') || this.haveRole('admin') || this.haveRole('Root')
        //                 // routerLink: ['/dd/cp/ecommerce']
        //             }
        //         ]
        //     },
        //     {
        //         label: 'ADMINISTRACIÓN',
        //         items: [
        //             {
        //                 label: 'Reportes',
        //                 icon: 'pi pi-fw pi-chart-bar',
        //                 visible: this.haveRole('warehouse_operator') || this.haveRole('delivery_person') || this.haveRole('manager') || this.haveRole('admin') || this.haveRole('Root'),
        //                 items: [
        //                     {
        //                         label: 'Entrada vs Salida',
        //                         icon: 'pi pi-fw pi-chart-line',
        //                         visible: this.haveRole('manager') || this.haveRole('admin') || this.haveRole('Root')
        //                         // routerLink: ['/dd/cp/report/movement']
        //                     },
        //                     {
        //                         label: 'Inventario General',
        //                         icon: 'pi pi-fw pi-database',
        //                         visible: this.haveRole('warehouse_operator') || this.haveRole('manager') || this.haveRole('admin') || this.haveRole('Root')
        //                         // routerLink: ['/dd/cp/report/general']
        //                     },
        //                     {
        //                         label: 'Inventario por Depósito',
        //                         icon: 'pi pi-fw pi-database',
        //                         visible: this.haveRole('warehouse_operator') || this.haveRole('manager') || this.haveRole('admin') || this.haveRole('Root')
        //                         // routerLink: ['/dd/cp/report/inventory-branch']
        //                     },
        //                     {
        //                         label: 'Delivery Tracking',
        //                         icon: 'pi pi-fw pi-truck',
        //                         visible: this.haveRole('warehouse_operator') || this.haveRole('delivery_person') || this.haveRole('manager') || this.haveRole('admin') || this.haveRole('Root')
        //                         // routerLink: ['/dd/cp/report/delivery-tracking']
        //                     }
        //                 ]
        //             },
        //             {
        //                 label: 'Configuración',
        //                 icon: 'pi pi-fw pi-cog',
        //                 visible: this.haveRole('manager') || this.haveRole('admin') || this.haveRole('Root'),
        //                 items: [
        //                     {
        //                         label: 'Productos',
        //                         icon: 'pi pi-fw pi-tags',
        //                         visible: this.haveRole('manager') || this.haveRole('admin') || this.haveRole('Root')
        //                         // routerLink: ['/dd/cp/settings/products']
        //                     },
        //                     {
        //                         label: 'Categorias',
        //                         icon: 'pi pi-fw pi-list-check',
        //                         visible: this.haveRole('manager') || this.haveRole('admin') || this.haveRole('Root')
        //                         // routerLink: ['/dd/cp/settings/categories']
        //                     },
        //                     {
        //                         label: 'Depósitos y Stock',
        //                         icon: 'pi pi-fw pi-map-marker',
        //                         visible: this.haveRole('manager') || this.haveRole('admin') || this.haveRole('Root')
        //                         // routerLink: ['/dd/cp/settings/warehause-stock']
        //                     },
        //                     {
        //                         label: 'Sucusales',
        //                         icon: 'pi pi-fw pi-shop',
        //                         visible: this.haveRole('manager') || this.haveRole('admin') || this.haveRole('Root')
        //                         // routerLink: ['/dd/cp/settings/branch']
        //                     },
        //                     {
        //                         label: 'Timbrados',
        //                         icon: 'pi pi-fw pi-receipt',
        //                         visible: this.haveRole('manager') || this.haveRole('admin') || this.haveRole('Root')
        //                         // routerLink: ['/dd/cp/settings/timbrado']
        //                     },
        //                     {
        //                         label: 'Roles y Usuarios',
        //                         icon: 'pi pi-fw pi-id-card',
        //                         visible: this.haveRole('manager') || this.haveRole('admin') || this.haveRole('Root')
        //                         // routerLink: ['/dd/cp/settings/user-rol']
        //                     }
        //                 ]
        //             }
        //         ]
        //     }
        // ];
    }
}
